var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToDoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83352 17.3208V16L10.1883 17.3208H8.83352ZM19.5844 7.98084L11.3961 15.97L10.0413 14.6475L18.2296 6.66L19.5844 7.98084ZM22 8.00749L18.2296 4.32999L7.12514 15.1633V18.8408H10.8955L22 8.00749ZM16.3504 16.5H14.6386V20.3333H3.70838V3.66667H14.8128V5H16.5212V2H2V22H16.3504V16.5ZM5.41676 7.00033H12.2503V5.33367H5.41676V7.00033ZM5.41676 10.3337H9.68771V8.667H5.41676V10.3337ZM5.41676 13.667H7.12514V12.0003H5.41676V13.667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToDoIcon);
export default __webpack_public_path__ + "static/media/ToDoIcon.8814e97ce42f2cae0b3985a9941a1be3.svg";
export { ForwardRef as ReactComponent };